export default () => ({
  quarters: [],
  sectors: [],
  classifications: [],
  countries: [],
  stock_countries: [],
  secCodeStates: [],
  states: [],
  wwGroups: [],
  ownershipTCodes: [],
  news: [],
  market_caps: [
    { id: 1, name: 'Over $200 billion', from: null, to: null, selected: false },
    { id: 2, name: '$100 billion to $500 billion', from: null, to: null, selected: false },
    { id: 3, name: '$50 billion to $100 billion', from: null, to: null, selected: false },
    { id: 4, name: '$20 billion to $50 billion', from: null, to: null, selected: false },
    { id: 5, name: '$10 billion to $20 billion', from: null, to: null, selected: false },
    { id: 6, name: '$2 billion to $10 billion', from: null, to: null, selected: false },
    { id: 7, name: '$1 billion to $2 billion', from: null, to: null, selected: false },
    { id: 8, name: '$500 million to $1 billion', from: null, to: null, selected: false },
    { id: 9, name: '$250 million to $500 million', from: null, to: null, selected: false },
    { id: 10, name: 'Less than $250 million', from: null, to: null, selected: false }
  ]
})
